import React from "react";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import DescriptionIcon from "@material-ui/icons/Description";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

const useStyles = makeStyles((theme) => ({
  info: {
    backgroundColor: theme.palette.background.paper,
  },
}));

function PathwayInfo(props) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid container justify="center" spacing={1}>
        <Grid item xs={12} md={10} style={{ textAlign: "center" }}>
          <div className={classes.info}>
            <List dense={true}>
              <ListItem>
                <ListItemIcon>
                  <DescriptionIcon />
                </ListItemIcon>
                <ListItemText primary={props.summary} />
              </ListItem>
            </List>
          </div>
        </Grid>
      </Grid>
      <Grid container justify="center" spacing={1}>
        <Grid item xs={12} md={10}>
          <div className={classes.info}>
            <List dense>
              <ListItem>
                <ListItemIcon>
                  <AddIcon />
                </ListItemIcon>
                <ListItemText primary={props.benefits} />
              </ListItem>
            </List>
          </div>
        </Grid>
      </Grid>
      <Grid container justify="center" spacing={1}>
        <Grid item xs={12} md={10}>
          <div className={classes.info}>
            <List dense={true}>
              <ListItem>
                <ListItemIcon>
                  <RemoveIcon />
                </ListItemIcon>
                <ListItemText primary={props.downsides} />
              </ListItem>
            </List>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PathwayInfo;
